import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @ components
import { RadioButton } from 'commonsComponents/radioButton';
import { RadioButtonGroup } from 'commonsComponents/radioButtonGroup';
// @ actions
import { initSelectFilter, setSelectFilter } from 'actions/filters';

class RadioFilter extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            options: props.options
        };
    }

    componentDidMount() {
        const {
            filtersId,
            filterId,
            filterTag,
            filterType,
            immFilter,
            initialSelected,
            noFilterId,
            initSelectFilter,
            isTaggable
        } = this.props;
        const label = this.state.options.find(option => option.value == initialSelected).label;
        !immFilter && initSelectFilter(
            filtersId,
            filterId,
            noFilterId != initialSelected,
            initialSelected,
            initialSelected,
            filterType,
            label,
            filterTag,
            isTaggable
        );
    }

    handleRadioChange = (value) => {
        const {
            filtersId,
            filterId,
            noFilterId,
            setSelectFilter,
        } = this.props;
        const label = this.state.options.find(option => option.value == value).label;
        setSelectFilter(filtersId, filterId, noFilterId != value, value, label);
    }

    renderRadioButtons = () => {
        const { options } = this.state;
        return  options.map((option, i) => {
            const { label, value } = option;
            return <RadioButton key={i} label={label} value={value} />
        })
    }

    render() {
        const {
            className,
            errorMessage,
            errorState,
            filterId,
            immFilter,
            isHorizontal,
            optionalElement
        } = this.props;

        if (immFilter) {
            const selected = immFilter.get('selected');
            return (
                <RadioButtonGroup
                    className={className}
                    idPrefix={filterId}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    isHorizontal={isHorizontal}
                    name={filterId}
                    onChange={this.handleRadioChange}
                    optionalElement={optionalElement}
                    selectedValue={selected}
                >
                    { this.renderRadioButtons() }
                </RadioButtonGroup>
            );
        } else {
            return null
        }
    }
}

RadioFilter.defaultProps = {
    filterType: 'radioFilter',
    filterTag: undefined,
    isTaggable: true
}

RadioFilter.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    filterId: PropTypes.string.isRequired,
    filterTag: PropTypes.bool,
    filterType: PropTypes.string,
    filtersId: PropTypes.string.isRequired,
    immFilter: PropTypes.object,
    initSelectFilter: PropTypes.func,
    initialSelected: PropTypes.string.isRequired,
    isHorizontal: PropTypes.bool,
    isTaggable: PropTypes.bool,
    noFilterId: PropTypes.string.isRequired,
    optionalElement: PropTypes.object,
    options: PropTypes.array.isRequired,
    selectedValue: PropTypes.any,
    setSelectFilter: PropTypes.func
};

export default connect(
    null,
    {
        initSelectFilter,
        setSelectFilter
    }
)(RadioFilter);